import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { CpMovementResponseModel } from '../../helpers/objects/response/movement/cp-movement-response-model';
import { CpMovementRequestModel } from '../../helpers/objects/request/movement/cp-movement-request-model';

@Injectable({
  providedIn: 'root'
})
export class CpMovementsService {
  appConfig: EnvironmentModel = new EnvironmentModel();

  constructor(@Inject(APP_CONFIG) protected appConfigTemp: EnvironmentModel, private http: HttpClient) {
    this.appConfig = appConfigTemp;
  }

  getAll(token: string, request: CpMovementRequestModel): Observable<CpMovementResponseModel> {
    const params = new HttpParams({
      fromObject: request as any
    });

    return this.http
      .get<any>(this.appConfig.api + 'contracts/' + encodeURIComponent(token) + '/movements', { params })
      .pipe(map((response) => response.body as CpMovementResponseModel));
  }
}
